import styled from "@emotion/styled";
import { containerStyles } from "../Skeleton";
export const SkeletonRoot = styled.div`
  ${containerStyles};
`;
